import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthenticationService } from '../user/_services/authentication.service';
import { PsiData } from '../_models/psi-data';
import { CommonService } from '../_services/common.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService, private commonService:CommonService){

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const currentUser = this.authenticationService.currentUser;
      //user is logged in and has permissions
      if (currentUser && currentUser.permissions) {
          this.authenticationService.setUserLoggedIn(true);
          if(route.data.module && route.data.module.length > 0){
            let permAuth:boolean = this.checkModulePerm(route.data.module, route.data.operator);
            if(!permAuth){
              if(route.data.reroute){
                //check if we have permission to the reroute location to avoid multiple reroutes
                let canReroute:boolean = false;
                for(let i=0; i<this.router.config.length; i++){
                  let r = this.router.config[i];
                  if(r.path == route.data.reroute && this.checkModulePerm(r.data.module, r.data.operator)){
                    canReroute = true;
                    break;
                  }
                }
                if(canReroute){
                  if(route.params && route.params.id){
                    this.router.navigate([route.data.reroute.replace(":id", route.params.id)], route);
                  }
                  else{
                    this.router.navigate([route.data.reroute]);
                  }
                }else{
                  this.router.navigate(['/nopermission']);
                }
              }else{
                this.router.navigate(['/nopermission']);
              }
            }
            return permAuth;
          } else{ //no permissions check required
            return true;
          }
        } else if (route.queryParams['uid'] && route.queryParams['sid'] && route.queryParams['token']){
          let uid = route.queryParams['uid'];
          let sid = route.queryParams['sid'];
          let token = route.queryParams['token'];

          if(uid != null && uid != "" && sid != null && sid != "" && token != ""){
            let data = {userId: uid, session: sid, url: "https://prosightspecialty.oktapreview.com/login/sessionCookie?token="+ token};
            let psiData: PsiData = new PsiData();
            psiData.currentUser.SID = sid;
            psiData.currentUser.UID = uid;
            psiData.currentUser.COOKIE_TOKEN_URL = "https://prosightspecialty.oktapreview.com/login/sessionCookie?token="+ token;

            sessionStorage.setItem("psiData", JSON.stringify(psiData));
            this.authenticationService.antiForgery().subscribe(token => {
            this.authenticationService.authorize(data).subscribe(user=>{
              this.authenticationService.setUserLoggedIn(true);
              setTimeout(() => {
                this.router.navigateByUrl('/dashboard');
              }, 50);  
            },error=>{
              this.authenticationService.logout();
            });
          });
          }
          return true;
        }
        this.authenticationService.setUserLoggedIn(false);

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
  }

  checkModulePerm(module:[any], operator:string):boolean{
    let permAuth:boolean = false;
    if(module.length > 1 && operator){
      permAuth = this.commonService.checkPermissions(module, operator);
    }else{
      permAuth = this.commonService.checkPermission(module[0]);
    }
    return permAuth;
  }
  
}
